var kpi = (function () {

    var setUpKpi = function () {
        function getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
        var initialSlide = getRandomInt(
            0,
            $(".c-kpi__item").length - 1
        );
        function getRandomKpi(){
            $($(".c-kpi__item")[initialSlide]).addClass('visible');
        }
        function getRandomDisclaimer(){
            $($(".c-kpi__disclaimer-copy--mobile-item")[initialSlide]).addClass('visible');
        }
        if($(window).outerWidth() < 768){
            getRandomKpi();
            getRandomDisclaimer();
        }
        $( window ).resize(function() {
            if($(window).outerWidth() < 768){
                getRandomKpi();
                getRandomDisclaimer();
            }
        });

        var maxHeight = 0;
        // run resize kpi section after all images are loaded
        $(".c-kpi__icon img").on('load', function() {
            resizeKpiSection(); 
        }).each(function() {
            // if each load is completed
            if(this.complete) {
                $(this).trigger('load');
            }
        });
        // resize kpi section
        function resizeKpiSection(){
            $('.c-kpi__icon').each(function(){
                $(this).find('img').css({
                    maxWidth: $(this).find('img')[0].naturalWidth/2
                });
                if($(this).find('img')[0].naturalHeight > maxHeight){
                    maxHeight = $(this).find('img')[0].naturalHeight/2;
                }else{
                    maxHeight = maxHeight;
                }
            });
            $('.c-kpi__icon').css({height: maxHeight, lineHeight: maxHeight+'px'});
        }
        
        $( window ).on('load', function(){
            $('.c-kpi-widget').removeClass('loading');
        })
    };
  
    var init = function () {
      setUpKpi();
    };
  
    return {
      init: init
    };
})();
  
export default kpi;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/kpi.js